import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  focusSessionsCompleted: 0,
  focusMinutesTotal: 0,
  freedAnimalKeys: [],
  currentStreak: 0,
  longestStreak: 0,
  lastStudyDate: null,
  lastCompletion: null, // { animalKey, xpEarned } from the most recent completeFocusInterval call
};

const slice = createSlice({
  name: 'focus',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setFocusState(state, action) {
      const { focusSessionsCompleted, focusMinutesTotal, freedAnimalKeys, currentStreak, longestStreak, lastStudyDate } = action.payload;
      state.isLoading = false;
      state.focusSessionsCompleted = focusSessionsCompleted;
      state.focusMinutesTotal = focusMinutesTotal;
      state.freedAnimalKeys = freedAnimalKeys;
      state.currentStreak = currentStreak;
      state.longestStreak = longestStreak;
      state.lastStudyDate = lastStudyDate;
    },
    applyCompletion(state, action) {
      const { animalKey, xpEarned, freedAnimalKeys, workMinutes } = action.payload;
      state.lastCompletion = { animalKey, xpEarned };
      state.freedAnimalKeys = freedAnimalKeys;
      state.focusSessionsCompleted += 1;
      state.focusMinutesTotal += workMinutes;
    },
    clearLastCompletion(state) {
      state.lastCompletion = null;
    },
  },
});

export default slice.reducer;

const API = process.env.REACT_APP_HOST_API;

// ----------------------------------------------------------------------

export function fetchFocusState() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${API}/focus/state`);
      dispatch(slice.actions.setFocusState(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Focus/State/InternalError'));
    }
  };
}

export function completeFocusInterval(workMinutes) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API}/focus/complete-interval`, { workMinutes });
      dispatch(slice.actions.applyCompletion({ ...response.data.data, workMinutes }));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Focus/Complete/InternalError'));
    }
  };
}

export function clearLastCompletion() {
  return slice.actions.clearLastCompletion();
}
